<template>
  <div>
    <landing-create :content="createRoleContent"></landing-create>
    <landing-table-action
      :tablemetadata="tableMetaData"
      :tablecontent="tableContent"></landing-table-action>
  </div>
</template>

<script>
import LandingCreate from '../../components/layouts/LandingCreate.vue';
import LandingTableAction from '../../components/layouts/LandingTableAction.vue';

export default {
  name: 'DatabaseList',
  components: {
    LandingTableAction,
    LandingCreate,
  },
  data() {
    return {
      drawer: true,
      mini: true,
      search: '',
      createRoleContent: {
        pageTitle: 'Database',
        commands: [
          {
            link: 'DatabaseCreate',
            icon: 'mdi-plus-box',
            buttonName: 'Create Database',
          },
        ],
      },
      tableMetaData: {
        tableActions: [
          {
            text: 'Update',
            icon: 'mdi-application-edit-outline',
            route: 'UserList',
          },
          {
            text: 'View',
            icon: 'mdi-eye',
            route: 'UserCreate',
          },
        ],
        tableHeaders: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Description', value: 'description' },
          { text: 'Date Created', value: 'dateCreated' },
          { text: '', value: 'option' },
        ],
      },
      tableContent: {
        tableContents: {
          rows: [
            {
              databaseId: '1',
              name: 'Backup for Month of November',
              description: 'Backup for GS, GO, HBRCA, SPECIMEN FORMS',
              dateCreated: 'Nov 22, 2021, 8:05:15 PM',
            },
            {
              databaseId: '2',
              name: 'Backup for Month of December',
              description: 'Backup for GS, GO, HBRCA, SPECIMEN FORMS',
              dateCreated: 'Nov 22, 2021, 8:05:15 PM',
            },
          ],
        },
      },
      /*
      tableActions: [
        {
          text: 'Data Entry',
          icon: 'mdi-application-edit-outline',
          route: 'UserList',
        },
        {
          text: 'View',
          icon: 'mdi-eye',
          route: 'UserCreate',
        },
      ],
      tableHeaders: [
        {
          text: 'Title',
          align: 'start',
          sortable: true,
          value: 'title',
        },
        { text: 'Module', value: 'module' },
        { text: 'Status', value: 'status' },
        { text: 'Permissions', value: 'permission' },
        { text: '', value: 'option' },
      ],
      tableContents: {
        rows: [
          {
            roleId: '1',
            title: 'Terminology Server Owner',
            module: 'Terminology Server',
            status: 'Enabled',
            permission: '3',
          },
          {
            roleId: '2',
            title: 'Terminology Server Editor',
            module: 'Terminology Server',
            status: 'Enabled',
            permission: '33',
          },
        ],
      },
      */
    };
  },
};
</script>
<style scoped>
.create-action-button {
  /*color: white;*/
  border: none;
  background: none;
  outline: none;
  letter-spacing: 0;
}
.create-link {
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  display: flex;
  vertical-align: middle;
}
</style>
